export const MAX_PRODUCTS_PER_ROW_MOBILE = 2;

export const GUTTER_SPACE_MOBILE = 1;

export const NUMBER_OF_PRODUCTS_DESKTOP = 4;

export const PRODUCT_BOTTOM_MARGIN_DESKTOP = 20;

export const DESKTOP_PRODUCT_WIDTH = 260;
